const ROLE_HOME_PATH = {
  admin: '/',
  kasir: '/pos',
  investor: '/investor-daily-report',
};

export function roleHomePath(role) {
  const normalized = String(role || '').trim().toLowerCase();
  return ROLE_HOME_PATH[normalized] || '/';
}
